export default __webpack_public_path__ + "static/media/LeftSpark.66415096.svg";